import { http, HttpResponse } from 'msw';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

const DEMO_SECURITY_EVENTS = [
  {
    id: 1,
    event_type: 'LOGIN_SUCCESS',
    actor: 'user:42',
    ip_address: '192.168.1.100',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Chrome/125.0',
    details: { email: 'demo@tradesentinel.io' },
    created_at: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
  },
  {
    id: 2,
    event_type: 'TOKEN_REFRESH',
    actor: 'user:42',
    ip_address: '192.168.1.100',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Chrome/125.0',
    details: {},
    created_at: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
  },
  {
    id: 3,
    event_type: 'LOGIN_FAILED',
    actor: 'anonymous',
    ip_address: '203.0.113.42',
    user_agent: 'curl/8.4.0',
    details: { email: 'admin@tradesentinel.io', reason: 'Invalid credentials' },
    created_at: new Date(Date.now() - 2 * 3600 * 1000).toISOString(),
  },
  {
    id: 4,
    event_type: 'PASSWORD_CHANGED',
    actor: 'user:42',
    ip_address: '192.168.1.100',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Chrome/125.0',
    details: {},
    created_at: new Date(Date.now() - 5 * 24 * 3600 * 1000).toISOString(),
  },
  {
    id: 5,
    event_type: 'SESSION_REVOKED',
    actor: 'user:42',
    ip_address: '192.168.1.100',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Chrome/125.0',
    details: { revoked_session: 'sess-old-001' },
    created_at: new Date(Date.now() - 7 * 24 * 3600 * 1000).toISOString(),
  },
  {
    id: 6,
    event_type: 'LOGIN_SUCCESS',
    actor: 'user:42',
    ip_address: '10.0.0.45',
    user_agent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_4) Safari/604.1',
    details: { email: 'demo@tradesentinel.io' },
    created_at: new Date(Date.now() - 2 * 24 * 3600 * 1000).toISOString(),
  },
  {
    id: 7,
    event_type: 'LOGIN_FAILED',
    actor: 'anonymous',
    ip_address: '198.51.100.77',
    user_agent: 'python-requests/2.31.0',
    details: { email: 'test@example.com', reason: 'User not found' },
    created_at: new Date(Date.now() - 3 * 24 * 3600 * 1000).toISOString(),
  },
  {
    id: 8,
    event_type: 'API_KEY_CREATED',
    actor: 'user:42',
    ip_address: '192.168.1.100',
    user_agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) Chrome/125.0',
    details: { venue_connection_id: 1, exchange: 'BINANCE' },
    created_at: new Date(Date.now() - 10 * 24 * 3600 * 1000).toISOString(),
  },
];

export const demoSecurityEventsHandlers = [
  // ── List security events ──────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/admin/security-events`, ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '50', 10);
    const offset = parseInt(url.searchParams.get('offset') ?? '0', 10);

    const paged = DEMO_SECURITY_EVENTS.slice(offset, offset + limit);
    return HttpResponse.json({
      items: paged,
      total: DEMO_SECURITY_EVENTS.length,
      limit,
      offset,
    });
  }),
];
